import React from 'react';
import styled from '@emotion/styled';
import getAllUrlParams from '../../shared/utils/getAllUrlParams';
import CalendarCreateContent from './components/presentational/CalendarCreateContent';
import BuildThemeProvider from './BuildThemeProvider';

const PageWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  margin-top: ${(props) => (props.hideNav ? '0' : '49px')};
  height: ${(props) => (props.hideNav ? '100%' : 'calc(100% - 49px)')};
  width: 100%;
  background: ${({ theme }) => theme.colors.surfaceSecondary};
`;

const ContentWrapper = styled('div')`
  display: flex;
  position: relative;
  height: 100%;
`;

const CalendarCreateLayout = () => {
  // Check for hideNav query parameter
  const urlParams = getAllUrlParams(window.location.href, false);
  const hideNav = urlParams.hideNav === 'true';

  /* The Create Calendar route lives outside Calendar.js, so it needs Build's
   * provider itself or it renders in the app's light theme. */
  return (
    <BuildThemeProvider>
      <PageWrapper hideNav={hideNav}>
        <ContentWrapper>
          <CalendarCreateContent />
        </ContentWrapper>
      </PageWrapper>
    </BuildThemeProvider>
  );
};

CalendarCreateLayout.propTypes = {};
export default CalendarCreateLayout;
